import * as React from "react";
import {Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";
import {ILoginTabResponse} from "../../../../api/AdminAnalyticsApi";
import {formatMonthLabel} from "../shared/analytics.format";
import {
    axisTickStyle,
    chartColors,
    gridProps,
    gridStroke,
    legendStyle,
    NEW_VS_RETURNING_DESCRIPTION,
    tooltipStyle,
} from "../shared/analytics.constants";

interface INewVsReturningChartProps {
    newVsReturning: ILoginTabResponse["newVsReturning"];
}

export const NewVsReturningChart: React.FC<INewVsReturningChartProps> = (props) => {
    const totalNew = props.newVsReturning.reduce((sum, r) => sum + r.newUsers, 0);
    const totalReturning = props.newVsReturning.reduce((sum, r) => sum + r.returningUsers, 0);
    const totalAll = props.newVsReturning.reduce((sum, r) => sum + r.total, 0);
    const newUserRate = totalAll > 0 ? Math.round((totalNew / totalAll) * 100) : 0;

    return (
        <section className="admin-analytics__section">
            <div className="admin-analytics__section-header">
                <h2 className="admin-analytics__section-title">New vs. Existing Users</h2>
                <span className="admin-analytics__section-subtitle">
                    Unique first-time users vs. unique existing users per month
                </span>
            </div>
            <p className="admin-analytics__section-desc">{NEW_VS_RETURNING_DESCRIPTION}</p>
            <div className="admin-analytics__summary-grid">
                <div className="admin-analytics__summary-card admin-analytics__summary-card--total">
                    <div className="admin-analytics__summary-label">Total New Users</div>
                    <div className="admin-analytics__summary-value">{totalNew}</div>
                    <div className="admin-analytics__summary-note">first-time logins</div>
                </div>
                <div className="admin-analytics__summary-card admin-analytics__summary-card--internal">
                    <div className="admin-analytics__summary-label">Total Existing Users</div>
                    <div className="admin-analytics__summary-value">{totalReturning}</div>
                    <div className="admin-analytics__summary-note">unique returning users</div>
                </div>
                <div className="admin-analytics__summary-card admin-analytics__summary-card--external">
                    <div className="admin-analytics__summary-label">New User Rate</div>
                    <div className="admin-analytics__summary-value">{newUserRate}%</div>
                    <div className="admin-analytics__summary-note">of logins are first-timers</div>
                </div>
            </div>
            <h3 className="admin-analytics__subsection-title">New vs. Existing by Month</h3>
            <div className="admin-analytics__chart">
                <ResponsiveContainer width="100%" height={280}>
                    <BarChart data={props.newVsReturning}>
                        <CartesianGrid {...gridProps} />
                        <XAxis dataKey="month" tickFormatter={formatMonthLabel} tick={axisTickStyle}
                               axisLine={{stroke: gridStroke}} tickLine={false}/>
                        <YAxis tick={axisTickStyle} axisLine={false} tickLine={false}/>
                        <Tooltip
                            labelFormatter={(label) => formatMonthLabel(label as string)}
                            {...tooltipStyle} />
                        <Legend {...legendStyle} />
                        <Bar dataKey="newUsers" stackId="a" fill={chartColors.tealLight}
                             name="New Users"/>
                        <Bar dataKey="returningUsers" stackId="a" fill={chartColors.navy}
                             name="Existing Users"/>
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </section>
    );
};
